import React, { useEffect, useState } from "react";
import { useNavigate, Routes, Route } from "react-router-dom";
import { MdOutlineCancel, MdOutlineLogout } from "react-icons/md";
import { Menu, MenuItem, Sidebar } from "react-pro-sidebar";
import Recruiter from "./recruiter";
import {
  companyView,
  getLogoBySubdomain,
  getSmallLogoForWhiteLabeling,
  name,
} from "../../services/white_label";
import ReportScreen from "../reusble_components/reportScreen";
import logo from "../../assests/logo.png";
import InterviewsList from "./interviews";
import PricingPlan from "../reusble_components/Pricing/naukritube/pricingPlans";
import {
  AiOutlineShareAlt,
  AiOutlineSetting,
  AiOutlinePlusCircle,
  AiOutlineTag,
  AiOutlinePicRight,
  AiOutlineRocket,
} from "react-icons/ai";
import Profile from "./profile";
import RecruiterProf from "./recruiterProf";
import download from "../../assests/download.jpeg";
import defaultProfile from "../../assests/background.png";
import { useStores } from "../../store";
import { Observer } from "mobx-react";
import ReferAndEarn from "../dashboard/ReferAndEarn";
import Technology from "./technology";
import KnowMore from "../dashboard/knowMore";
import { GetMoreCreditsPopUp, RedeemCoupon } from "../dashboard/basicDetails";
import { PurchaseCredits } from "../dashboard/creditPoints";
import { MeetingCreationForm } from "../dashboard/MeetingCreation";
import Dashboard1 from "../recruiterNew/dashboard1";
import History from "./history.jsx";
import CreateNew from "./createNew";
import JobPost from "./jobPost";
import CompanyInterviewsList from "./companyInterview";
import { CompanyInterviewForm } from "./companyForm";
import Mcq from "./mcq";
import ApplicantsDetails from "./applicantsDetails";
import { useLocation } from "react-router-dom";
import JobApplicantDetails from "./jobApplicantDetails";
import MobileReportOverview from "./mobileOverview";
import Notification from "../dashboard/Notification";
import JobDetails from "../career/components/page";
import CompanyApplicants from "../recruiter/companyApplicants";
import ViewCredits from "../dashboard/viewCredits";
// import MoreSetting from "../reusble_components/cards/profile/moresetting";

import Resume from "./Resume/Resume";
import ResumeScore from "./Resume/ResumeScore";
import VerifyPopup from "../recruiter/Components/VerifyPopup";
import { apiPostPut } from "../../api/api_methods";
import Connect from "../dashboard/Connect";
import Popup from "../reusble_components/popup";
import { loginWarningImage } from "../../helpers/constantVariables";
import { setDataToLocalStorage } from "../../services/localStorage";
import MockExamReport from "../dashboard/mockexamreport";
import Tags from "../reusble_components/labels3/Tags";
import Discover from "../../services/discover";
import { RiDashboardFill } from "react-icons/ri";
import { toJS } from "mobx";

import ProgressBar from "../reusble_components/dashboard/profilecard";
import Profilepage from "../reusble_components/profile/Profilepage";
import ExportDataUI from "../reusble_components/export1/exportUi";
import ExportDataUI1 from "../reusble_components/export1/exportUi2";
import ExportDataUI3 from "../reusble_components/export1/exportUi3";
import ProfilePage1 from "../reusble_components/profile/profilePage1";
import InterviewSetting from "../interview/InterviewSetting";
import InterviewSetting2 from "../interview/InterviewSetting2";
import ScreenShareErrorCard from "../reusble_components/notifications/ScreenShareCardError";
import Assesment1 from "../reusble_components/Assesment/Assesment.jsx";
import ReportOverviewDummy from "../reusble_components/proxyReport/proxyReport";
import Component2 from "../reusble_components/Component/Component2.jsx";
import ExportApplicant from "../reusble_components/ExportApplicant.jsx";
import TotalApplicantsMobile from "../reusble_components/TotalApplicant3.jsx";
import SearchableDropdown from "../dashboard/DropDownSearchBar.jsx";
import CheckoutPage from "../reusble_components/Pricing/naukritube/CheckoutPage.jsx";
import TechnicalInterview from "./technicalInterview.jsx";
import { BsArrowClockwise } from "react-icons/bs";
import Alerts from "../reusble_components/popup/Alerts.jsx";
import PricePlans from "../reusble_components/Pricing/pricePlans.jsx";
import Subscription from "../reusble_components/Pricing/subscription.jsx";
import { IoDiamondOutline } from "react-icons/io5";
import PricingPlans2 from "../reusble_components/Pricing/naukritube/pricingPlan2.jsx";
import InstantHireCandidates from "./InstantHireCandidates";
import { getUserDetailsFromLocalStorage } from "../../services/reusable";

export default function DashboardRecruiter() {
  const navigate = useNavigate();
  const { UserStore, InterviewStore, RecuiterStore, PopupStore, CommonStore } =
    useStores();

  const [toggled, setToggled] = useState(false);
  const [broken, setBroken] = useState(false);
  const [collapsed, setCollapsed] = useState(false);

  const [activeIndex, setActiveIndex] = useState(0);
  const [accessTypeStatus, setAccessTypeStatus] = useState("unrestricted");

  const handleMenuItemClick = (index, action) => {
    setActiveIndex(index);
    if (index === "Talent Pool") {
      RecuiterStore.clearFilterState();
    }
    navigate(action);
  };

  const [activePlan, setActivePlan] = useState(null);

  // useEffect(() => {
  //   const fetchSubscriptions = async () => {
  //     await UserStore.checkSubscription();
  //     const activeSubscription = UserStore.previousSubscriptions;
  //     console.log(toJS(activeSubscription), "activeSubscription");
  //     setActivePlan(toJS(activeSubscription));
  //   };

  //   fetchSubscriptions();
  // }, []);

  useEffect(() => {
    UserStore.getUserDetails();
  }, []);

  const getIconClass = (isActive) => {
    return isActive ? "text-primary" : "text-gray-500";
  };

  // useEffect(() => {
  //   // if (JSON.parse(localStorage.getItem("user"))?.role?.role !== "company") {
  //   //   navigate("/company/dashboard");
  //   // }

  //   if (RecuiterStore.clients?.length === 0) {
  //     RecuiterStore.fetchClients();
  //   }
  // }, []);

  const icon = <AiOutlineShareAlt className="text-3xl text-primary" />;
  function showReferAndEarn(onClick) {
    PopupStore.setReferAndEarn(true);
    if (onClick) {
      onClick();
    }
  }

  //Access Type
  const accessType = async () => {
    const user = await getUserDetailsFromLocalStorage();
    console.log(user, "user");
    if (user?.access) {
      console.log(user?.access[0]?.accessType, "user?.access[0]?.accessType");
      const status =
        user?.access[0]?.accessType === "6971bb50ce17d9413a277db4"
          ? "restricted"
          : "unrestricted";
      console.log(status, "status11");
      return status;
    }
    return "unrestricted";
  };

  useEffect(() => {
    const fetchAccessType = async () => {
      const access = await accessType();
      console.log(access, "access");
      setAccessTypeStatus(access);
    };
    fetchAccessType();
  }, []);

  const [collapseDelay, setCollapseDelay] = useState(true);
  const handleClickopen = () => {
    CommonStore.setCollapse(!CommonStore.collapse);
    delay(1000);
  };
  const coloumnList = [
    {
      label: "Dashboard",
      //   icon: <Tooltip />,
      activeIcon: <RiDashboardFill size="1.5rem" />,
      show: companyView("home"),
      action: "/company/dashboard",
      mobileShow: true,
    },
    // {
    //   label: "Instant Hire",
    //   //   icon: <Tooltip />,
    //   activeIcon: <AiOutlineRocket className="text-3xl " />,
    //   action: "/company/instant-hire",
    //   url: ["/company/instant-hire"],
    //   show: companyView("instant"),
    //   mobileShow: true,
    // },
    // {
    //   label: "Inteviews",
    //   activeIcon: <AiOutlineUsergroupAdd className="text-3xl " />,
    //   action: "/company/interviews",
    // },
    {
      label: "Services",
      activeIcon: <AiOutlinePlusCircle size="1.5rem" />,
      action: "/company/services",
      url: [
        "/company/services",
        "/company/job-post",
        "/company/technical-interview",
        "/company/hr-interview",
        "/company/mcq",
        "/company/resume",
      ],
      show: companyView("service") && accessTypeStatus === "unrestricted",
      mobileShow: true,
    },
    // {
    //   label: "Resume Analyzer",
    //   activeIcon: <AiOutlineFileText className="text-3xl " />,
    //   action: "/company/resume",
    //   url: ["/company/resume", "/company/resumescore"],
    //   show: companyView("resume"),
    // },

    {
      label: "Activity",
      activeIcon: <BsArrowClockwise size="1.5rem" />,
      action: "/company/activity",
      url: [
        "/company/activity",
        "/company/job-applicants",
        "/company/jobpost/",
        "/company/applicants",
        "/company/mocktest-applicants",
        "/company/settings/",
        "/report/",
        "/company/mocktest-applicants",
      ],
      show: companyView("history"),
      mobileShow: true,
    },
    {
      label: "Talent Pool",
      activeIcon: <AiOutlinePicRight size="1.5rem" />,
      action: `/company/talent-pool?page=${RecuiterStore.previousPageForTalentPool}`,
      url: [`/company/talent-pool`],
      show: companyView("applicant"),
      mobileShow: true,
    },
    {
      label: "Tags",
      activeIcon: <AiOutlineTag size="1.5rem" />,
      action: "/company/tags",
      show: companyView("labels"),
      mobileShow: true,
    },
    {
      label: "Settings",
      activeIcon: <AiOutlineSetting size="1.5rem" />,
      action: "/company/settings",
      url: ["/company/settings"],
      show: companyView("profile"),
      mobileShow: false,
    },

    // {
    //   label: "Interview",
    //   //   icon: <2 />,
    //   activeIcon: <AiOutlineBook className="text-3xl " className="text-primary" />,
    //   action: "/dashboard/learn",
    // },

    // {
    //   label: "Profile",
    //   //   icon: <Tooltip3 />,
    //   activeIcon: (
    //     <MdOutlineAccountCircle className="text-3xl " className="text-primary" />
    //   ),
    //   action: "/dashboard/profile",
    // },
  ];

  const companyPlans = [
    {
      id: "69005f38017933664964e095",
      // id: "67cad464cc2bec83fe4e8ad2",
      name: "Starter Plan",
      price: 999,
      duration: 1,
      // originalPrice: "₹11,999",
      features: [
        { text: "AI Resume Analyser", available: true, value: 100 },
        { text: "AI Interviews", available: true, value: 20 },
        { text: "MCQ's", available: true, value: 200 },
        { text: "Reports", available: true },
        { text: "ATS Dashboard", available: true },
        { text: "Tags", available: true },
        { text: "Salary recommendation", available: true },
        { text: "Proxy detection", available: true },
        { text: "Job Post/Month", available: true, value: 2 },
        { text: "Login", available: true, value: 3 },
        { text: " Day Interview Backup", available: true, value: 15 },
        { text: "Dedicated HR Support", available: false },
        { text: "White Labelling", available: true },
        { text: "Shared Support", available: true },
      ],
    },
    {
      // id: "684044aa8f1c3fd3eb664324",
      id: "6900603c017933664964e098",
      name: "Advanced Plan",
      price: 2999,
      duration: 1,
      // originalPrice: "₹11,999",
      features: [
        { text: "AI Resume Analyser", available: true, value: 200 },
        { text: "AI Interviews", available: true, value: 60 },
        { text: "MCQ's", available: true, value: 200 },
        { text: "Reports", available: true },
        { text: "ATS Dashboard", available: true },
        { text: "Tags", available: true },
        { text: "Salary recommendation", available: true },
        { text: "Proxy detection", available: true },
        { text: "Job Post/Month", available: true, value: 2 },
        { text: "Login", available: true, value: 5 },
        { text: " Day Interview Backup", available: true, value: 60 },
        { text: "Dedicated HR Support", available: true },
        { text: "White Labelling", available: true },
        { text: "Shared Support", available: true },
      ],
    },
    {
      id: 2,
      name: "Custom Plan",
      price: 0,
      duration: 1,
      // originalPrice: "₹18,499",
      features: [
        { text: "AI Resume Analyser", available: true },
        { text: "AI Interviews", available: true },
        { text: "MCQ's", available: true },
        { text: "Reports", available: true },
        { text: "ATS Dashboard", available: true },
        { text: "Tags", available: true },
        { text: "Salary recommendation", available: true },
        { text: "Proxy detection", available: true },
        { text: "Job Post/Month", available: true },
        { text: "Login", available: true, value: 10 },
        { text: "Day Interview Backup", available: true },
        { text: "In App Auto Emails", available: true },
        { text: "White Labelling", available: true },
        { text: "Shared Support", available: true },
      ],
    },
  ];

  const yearlyPlans = [
    {
      // id: "6840425a8f1c3fd3eb663f82",
      id: "690060ca017933664964e099",
      name: "Starter Plan",
      price: 9588,
      monthPrice: 799,
      duration: 12,
      features: [
        { text: "AI Resume Analyser", available: true, value: 100 },
        { text: "AI Interviews", available: true, value: 20 },
        { text: "MCQ's", available: true, value: 200 },
        { text: "Reports", available: true },
        { text: "ATS Dashboard", available: true },
        { text: "Tags", available: true },
        { text: "Salary recommendation", available: true },
        { text: "Proxy detection", available: true },
        { text: "Job Post/Month", available: true, value: 2 },
        { text: "Login", available: true, value: 3 },
        { text: " Day Interview Backup", available: true, value: 15 },
        { text: "Dedicated HR Support", available: false },
        { text: "White Labelling", available: true },
        { text: "Shared Support", available: true },
      ],
    },
    {
      // id: "684043ce8f1c3fd3eb664007",
      id: "69006244017933664964e09a",
      name: "Advanced Plan",
      price: 23788,
      monthPrice: 2399,
      duration: 12,
      features: [
        { text: "AI Resume Analyser", available: true, value: 200 },
        { text: "AI Interviews", available: true, value: 60 },
        { text: "MCQ's", available: true, value: 200 },
        { text: "Reports", available: true },
        { text: "ATS Dashboard", available: true },
        { text: "Tags", available: true },
        { text: "Salary recommendation", available: true },
        { text: "Proxy detection", available: true },
        { text: "Job Post/Month", available: true, value: 2 },
        { text: "Login", available: true, value: 5 },
        { text: " Day Interview Backup", available: true, value: 60 },
        { text: "Dedicated HR Support", available: true },
        { text: "White Labelling", available: true },
        { text: "Shared Support", available: true },
      ],
    },
    {
      id: 2,
      name: "Custom Plan",
      price: 0,
      duration: 1,
      // originalPrice: "₹18,499",
      features: [
        { text: "AI Resume Analyser", available: true },
        { text: "AI Interviews", available: true },
        { text: "MCQ's", available: true },
        { text: "Reports", available: true },
        { text: "ATS Dashboard", available: true },
        { text: "Tags", available: true },
        { text: "Salary recommendation", available: true },
        { text: "Proxy detection", available: true },
        { text: "Job Post/Month", available: true },
        { text: "Login", available: true, value: 10 },
        { text: "Day Interview Backup", available: true },
        { text: "In App Auto Emails", available: true },
        { text: "White Labelling", available: true },
        { text: "Shared Support", available: true },
      ],
    },
  ];

  const getIconAsperUrl = (item) => {
    // if (window.location.pathname === item.action) {
    //   return item?.activeIcon;
    // } else {
    //   return item?.icon;
    // }
    return item?.activeIcon;
  };
  const location = useLocation();
  useEffect(() => {
    const currentPath = location.pathname;
    const matchedItem = coloumnList.find(
      (item) =>
        item.action === currentPath ||
        (item.url && item.url.some((url) => currentPath.includes(url))),
    );
    if (matchedItem) {
      setActiveIndex(matchedItem.label);
    } else if (currentPath === "/company") {
      setActiveIndex("Instant Hire");
    }
  }, [location]);

  useEffect(() => {
    if (!location.pathname.includes("applicants")) {
      // CommonStore.setCollapse(false);
      // alert(1)
      return;
    } else {
      CommonStore.setCollapse(true);
      return;
    }
  }, [location.pathname]);

  // useEffect(() => {
  //   // alert(2)
  //   // CommonStore.setCollapse(false);
  //   if (!UserStore.bannerHit) {
  //     getbanner();
  //     UserStore.setBannerHit(true);
  //     return;
  //   }
  // }, []);

  const getbanner = async () => {
    const userDetails = JSON.parse(localStorage.getItem("user"));
    const data = {
      clusterId: userDetails?.cluster,
    };
    const response = await apiPostPut(
      data,
      "/admin/get-active-banner?usedFor=company",
      "POST",
    );
    if (response.status === 200) {
      console.log("response", response.body.data);
      console.log("response", response.body.data);
      if (response.body.data < 0) {
        setShowTechFusionHeader(false);
      }

      setBanner(response.body.data);
      setShowTechFusionHeader(true);
    } else {
      setShowTechFusionHeader(false);
    }
  };

  useEffect(() => {
    if (!JSON.parse(localStorage.getItem("user"))?.role?.role) {
      PopupStore.setLoginWarning(true);
    }
  }, [activeIndex]);

  const redirectToSignupPageWithCurrentUrl = () => {
    const currentPath = window.location.href;

    // set currentPath in local storage
    setDataToLocalStorage("redirectUrl", currentPath);

    const signupUrl = `/`;

    console.log(signupUrl);

    navigate(signupUrl);
  };

  const logOut = () => {
    localStorage.clear();
    sessionStorage.clear();
    window.location.replace("/login");
  };
  const [openDelay, setOpenDelay] = useState(false);
  const delay = (delayInms) => {
    const timer = setTimeout(() => setCollapseDelay(true), delayInms);
    return () => clearTimeout(timer);
  };
  const [banner, setBanner] = useState(null);
  const [showTechFusionHeader, setShowTechFusionHeader] = useState(false);
  const openGoogleForms = () => {
    window.location.href = banner.link;
  };
  const handleCloseTechFusionHeader = () => {
    setShowTechFusionHeader(false);
  };
  const handleLogoClick = () => {
    // Redirect to the main page
    navigate("/company/dashboard");
  };

  const [sidebarWidth, setSidebarWidth] = useState("5%");
  const [selectedItem, setSelectedItem] = useState(0);
  // check if the user is in mobile view
  const isMobile = window.innerWidth < 768;
  return (
    <Observer>
      {() => (
        <>
          <Alerts />
          {/* {PopupStore.loginWarning && (
            <Popup
              popUpInitialValue={PopupStore.loginWarning}
              handlePopup={() => {
                PopupStore.setLoginWarning(false);
              }}
              image={loginWarningImage}
              content="Please login to access the content"
              buttontext="Signup now"
              onClick={() => {
                redirectToSignupPageWithCurrentUrl();
                PopupStore.setLoginWarning(false);
              }}
            />
          )} */}
          <VerifyPopup />
          {PopupStore.referAndEarn && (
            <ReferAndEarn
              popUpInitialValue={PopupStore.referAndEarn}
              handlePopup={() => {
                PopupStore.setReferAndEarn(false);
              }}
            />
          )}
          {PopupStore.KnowMore && (
            <KnowMore
              popUpInitialValue={PopupStore.KnowMore}
              handlePopup={() => {
                PopupStore.setKnowMore(false);
              }}
            />
          )}
          {PopupStore.getMoreCredits && (
            <GetMoreCreditsPopUp
              popUpInitialValue={PopupStore.getMoreCredits}
              handlePopup={() => {
                PopupStore.setGetMoreCredits(false);
              }}
              referAndEarnHide={true}
            />
          )}
          {PopupStore.redeemCoupon && (
            <RedeemCoupon
              popUpInitialValue={true}
              handlePopup={() => {
                PopupStore.setRedeemCoupon(false);
              }}
            />
          )}
          {PopupStore.notification && (
            <Notification
              popUpInitialValue={PopupStore.notification}
              handlePopup={() => {
                PopupStore.setNotification(false);
              }}
            />
          )}
          {PopupStore.connectPopup && <Connect />}
          {PopupStore.paymentGateway && (
            <PurchaseCredits
              gateWay="phonePe"
              onClose={() => {
                PopupStore.setPaymentGateway(false);
              }}
            />
          )}
          <div className="home-page-parent relative">
            {showTechFusionHeader ? (
              <div
                className=" bg-black text-white py-1 lg:h-6 flex items-center justify-center !h-6"
                style={{
                  backgroundImage: `${banner?.backgroundColor}`,
                }}
              >
                <img
                  src={banner?.image}
                  className="w-4 h-4 mr-4  "
                  alt="banner image"
                />
                <p className=" text-xs lg:py-6">
                  <span className="font-semibold">{banner?.content} </span>
                  <a
                    onClick={openGoogleForms}
                    className="cursor-pointer underline font-semibold px-1"
                  >
                    {banner?.buttonLabel}
                  </a>{" "}
                </p>
                <button onClick={handleCloseTechFusionHeader}>
                  <MdOutlineCancel className="ml-1 text-xs lg:text-lg text-white cursor-pointer" />
                </button>
                {/* <button className="ml-1 underline">View More</button> */}
              </div>
            ) : null}
            <header
              className="shadow-lg fixed bg-white top-0 left-0 mt-0 ml-0 z-40 w-screen md:hidden  "
              id="mobile-header"
            >
              {showTechFusionHeader ? (
                <div
                  className=" bg-black text-white py-1 lg:h-6 flex items-center justify-center !h-6"
                  style={{
                    backgroundImage: `${banner?.backgroundColor}`,
                  }}
                >
                  <img
                    src={banner?.image}
                    className="w-4 h-4 mr-4  "
                    alt="banner image"
                  />
                  <p className=" text-xs lg:py-6">
                    <span className="font-semibold">{banner?.content} </span>
                    <a
                      onClick={openGoogleForms}
                      className="cursor-pointer underline font-semibold px-1"
                    >
                      {banner?.buttonLabel}
                    </a>{" "}
                  </p>
                  <button onClick={handleCloseTechFusionHeader}>
                    <MdOutlineCancel className="ml-1 text-xs lg:text-lg text-white cursor-pointer" />
                  </button>
                  {/* <button className="ml-1 underline">View More</button> */}
                </div>
              ) : null}
              <div className=" mt-0 ml-0 bg-transparent  mx-5 h-16 top-0 left-0 z-40  bg-bg2 flex items-center justify-between  ">
                {/* <div className="">
                  {broken && (
                    <button
                      className="sb-button m-4"
                      onClick={() => {
                        setToggled(!toggled);
                        CommonStore.setCollapse(false);
                      }}
                    >
                      <MdOutlineMenu size={"2rem"} />
                    </button>
                  )}
                </div> */}
                <img
                  className="object-cover h-[20px] pl-4 "
                  src={getLogoBySubdomain(logo)}
                  onClick={() => {
                    navigate("/company/dashboard");
                    console.log("dashvboard clickwe3");
                    console.log(getLogoBySubdomain(isMobile));
                    console.log("dashvboard clickwe3");
                  }}
                  alt=""
                />

                <div className="flex justify-center items-center">
                  {/* <MdNotifications
                    onClick={() => {
                      PopupStore.setNotification(true);
                    }}
                    className="text-2xl"
                  /> */}
                  <img
                    src={download}
                    alt=" "
                    className="w-[30px] h-[30px] rounded-full"
                    style={{
                      backgroundImage: `url(${defaultProfile})`,
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                    }}
                    onClick={() => {
                      navigate("/company/settings");
                    }}
                  />
                </div>
              </div>
            </header>
            <div className="flex h-[100%] m-0 mt-16 md:mt-0  p-0 bg-black">
              {/* <Sidebar
                collapsed={CommonStore.collapse}
                onBackdropClick={() => setToggled(false)}
                onBreakPoint={setBroken}
                className="z-10 w-[250px] shadow-2xl shadow-slate-200"
                breakPoint="md"
                backgroundColor="black"
                transitionDuration={500}
                width="190px"
                onMouseEnter={() => {
                  CommonStore.settempCollapse(CommonStore.collapse);
                  CommonStore.setCollapse(false); // Expand on hover
                  console.log("Mouse hovered");
                }}
                onMouseLeave={() => {
                  console.log("Mouse Left");
                  CommonStore.setCollapse(CommonStore.tempCollapse); // Revert to previous state
                  console.log("Mouse left");
                }}
              >
                <Menu className=" top-0 menu-item-sidebar">
                  <div className="flex flex-row items-center mt-11 px-1 gap-2 justify-center w-full">
                    {!CommonStore.collapse ? (
                      <>
                        <img
                          src={getLogoBySubdomain()}
                          className="w-[90%]  cursor-pointer"
                          alt="Large Logo"
                          onClick={() => {
                            navigate("/company/dashboard");
                            console.log("dashvboard clickwe3");
                          }}
                          alt="Large Logo"
                          onClick={() => {
                            navigate("/company/dashboard");
                            console.log("dashvboard clickwe3");
                          }}
                        />
                      </>
                    ) : (
                      <img
                        src={getSmallLogoForWhiteLabeling()}
                        className="w-[70%] cursor-pointer -my-5 object-contain"
                        alt="Small Logo"
                      />
                    )}
                  </div>
                </Menu>
                <Menu
                  className={`absolute menu-item-sidebar top-20 mt-[30%] hover:text-[#ff6b00]`}
                >
                  {coloumnList.map((item, index) => {
                    if (item.show === false) {
                      return null; // Skip rendering this menu item if 'show' is false
                    }
                    const isActive = item.label === activeIndex;
                    return (
                      <MenuItem
                        onClick={() => {
                          if (window.innerWidth < 1000) {
                            setToggled(!toggled);
                          }
                          handleMenuItemClick(item.label, item.action);
                        }}
                        key={index}
                        // icon={

                        // }
                        className={`items-center ${
                          isActive
                            ? "text-[#ff6b00] border-l-4 border-[#F1EAE0]"
                            : "text-white hover:text-[#ff6b00]"
                        } hover:bg-[#F1EAE0] hover:text-[#ff6b00] `}
                      >
                        {!CommonStore.collapse ? (
                          <div className="hover:text-primary flex gap-4">
                            {getIconAsperUrl(item)}
                            {item.label}
                          </div>
                        ) : (
                          <div className="flex gap-4">
                            {getIconAsperUrl(item)}
                          </div>
                        )}
                      </MenuItem>

                     
                    );
                  })}
                </Menu>

                <Menu className="absolute bottom-0 menu-item-sidebar">
                  <MenuItem
                    onClick={() => logOut()}
                    icon={<MdOutlineLogout color="red" className="" />}
                  >
                    Logout
                  </MenuItem>
                </Menu>
              </Sidebar> */}
              <Sidebar
                collapsed={CommonStore.collapse}
                transitionDuration={500}
                width={`${sidebarWidth} !important`}
                backgroundColor="black"
                border={`${
                  sidebarWidth === "12%"
                    ? "border-r-0 border-black"
                    : "border-r-0 border-black"
                }`}
                className={`
    z-[1000] bg-black m-0 md:block lg:block hidden !fixed p-0
  `}
                style={{ borderRight: "1px solid black" }} // <- This makes the white line black
                onMouseEnter={() => {
                  setSidebarWidth("12%");
                  console.log("Mouse hovered");
                }}
                onMouseLeave={() => {
                  setSidebarWidth("5%");
                  console.log("Mouse left");
                }}
              >
                <div className="py-5 hidden md:flex md:justify-between md:items-center w-full">
                  <div
                    className="py-4 hidden md:flex md:justify-center w-[90%] mx-2 h-20"
                    onClick={handleLogoClick}
                  >
                    {sidebarWidth === "12%" ? (
                      <img
                        src={getLogoBySubdomain()}
                        className="w-[90%] object-contain cursor-pointer"
                        alt="Large Logo"
                      />
                    ) : (
                      <img
                        src={getSmallLogoForWhiteLabeling()}
                        className="w-[70%] cursor-pointer -my-5 object-contain"
                        alt="Small Logo"
                      />
                    )}
                  </div>
                </div>

                <Menu
                  className={`mt-[11%] ${
                    sidebarWidth === "12%" ? "mx-[0%]" : "mx-0"
                  }`}
                >
                  {coloumnList.map((item, index) => {
                    if (item.show === false) {
                      return null;
                    }
                    const isActive = item.label === activeIndex;
                    return (
                      <MenuItem
                        onClick={() => {
                          navigate(item.action);
                          handleMenuItemClick(item.label, item.action);
                        }}
                        key={index}
                        icon={getIconAsperUrl(item)}
                        className={`${
                          CommonStore.collapse ? "text-white" : "text-sm"
                        } items-center menu-item-sidebar md:h-12 lg:text-lg text-base ${
                          isActive
                            ? "!text-primary border-l-4 bg-black"
                            : "hover:bg-[#F1EAE0] hover:text-[#ff6b00]"
                        }`}
                      >
                        <p
                          className={`${
                            sidebarWidth === "12%" ? "" : "hidden"
                          }`}
                        >
                          {item.label}
                        </p>
                      </MenuItem>
                    );
                  })}
                </Menu>

                {name() === "Naukritube" && (
                  <Menu className="absolute bottom-0 menu-item-sidebar">
                    <tooltip
                      id="premiumToolTip"
                      position="top"
                      content="Try Premium!"
                    >
                      <MenuItem
                        onClick={() => {
                          // if (activePlan) {
                          //   alert(
                          //     "You are already subscribed to a " +
                          //       activePlan.planId.name
                          //   );
                          //   return;
                          // }
                          navigate("/company/pricing-plans1");
                        }}
                        icon={
                          <IoDiamondOutline
                            color="primary"
                            className=" transform text-primary text-2xl lg:text-4xl"
                          />
                        }
                        className={`${
                          CommonStore.collapse ? "text-[#999]" : "text-sm "
                        } flex items-center 0 lg:text-2xl text-primary`}
                      >
                        <p
                          className={`${
                            sidebarWidth === "12%" ? "" : "hidden"
                          } font-semibold`}
                        >
                          {activePlan
                            ? activePlan?.planId?.name
                            : "Try Premium!"}
                        </p>
                      </MenuItem>
                    </tooltip>
                  </Menu>
                )}
                {name() !== "Naukritube" && (
                  <Menu className="absolute bottom-0 menu-item-sidebar">
                    <tooltip
                      id="premiumToolTip"
                      position="top"
                      content="Try Premium!"
                    >
                      <MenuItem
                        onClick={() => {
                          // if (activePlan) {
                          //   alert(
                          //     "You are already subscribed to a " +
                          //       activePlan.planId.name
                          //   );
                          //   return;
                          // }
                          navigate("/company/subscription");
                        }}
                        icon={
                          <IoDiamondOutline
                            color="primary"
                            className=" transform text-primary text-2xl lg:text-4xl"
                          />
                        }
                        className={`${
                          CommonStore.collapse ? "text-[#999]" : "text-sm "
                        } flex items-center 0 lg:text-2xl text-primary`}
                      >
                        <p
                          className={`${
                            sidebarWidth === "12%" ? "" : "hidden"
                          } font-semibold`}
                        >
                          {activePlan
                            ? activePlan?.planId?.name
                            : "Try Premium!"}
                        </p>
                      </MenuItem>
                    </tooltip>
                  </Menu>
                )}
              </Sidebar>

              {/* Mobile Nav bar */}
              <div className="fixed bottom-0 left-0 w-[100vw] !h-16 px-2 py-2 z-50 bg-black md:hidden meeting-form-shadow squared-t-lg">
                <div className="flex justify-between items-center gap-0 w-full h-full">
                  {/* <Menu
                  className={`mt-[11%] ${
                    sidebarWidth === "12%" ? "mx-[0%]" : "mx-0"
                  }`}
                >
                  {coloumnList.map((item, index) => {
                    if (item.show === false) {
                      return null; // Skip rendering this menu item if 'show' is false
                    }
                    const isActive = item.label === activeIndex;
                    return (
                      <MenuItem
                        onClick={() => {
                          navigate(item.action);
                          handleMenuItemClick(item.label, item.action);
                        }}
                        key={index}
                        icon={getIconAsperUrl(item)}
                        className={`${
                          CommonStore.collapse ? "text-white" : "text-sm"
                        } items-center menu-item-sidebar md:h-12 lg:text-lg text-base ${
                          isActive
                            ? "!text-primary border-l-4 bg-black"
                            : " hover:bg-[#F1EAE0] hover:text-[#ff6b00]"
                        }`}
                      >
                        {item.label}
                      </MenuItem>
                    );
                  })}
                </Menu> */}
                  {/* {view("home") && (
                                  <button
                                    onClick={() => {
                                      navigate("/dashboard/dashboard");
                                      CommonStore.setBottomNavigationIndex(0);
                                    }}
                                    className={`w-[20%] h-16 focus:outline-none text-gray-400 flex  flex-col items-center justify-center ${
                                      CommonStore.bottomNavigationIndex === 0
                                        ? "  border-b-2 border-primary text-primary bg-opacity-40"
                                        : ""
                                    }`}
                                  >
                                    {CommonStore.bottomNavigationIndex !== 0 && (
                                      <LuHome size={28} className={`opacity-70`} />
                                    )}
                                    {CommonStore.bottomNavigationIndex === 0 && (
                                      <LuHome size={28} className={``} />
                                    )}
                      
                                    <span className={`text-xs mt-1 opacity-100`}>Home</span>
                                  </button>
                                )} */}
                  {coloumnList.map((item, index) => {
                    if (!item.show || !item.mobileShow) {
                      return null; // Skip items that are not meant to be shown
                    }

                    const isActive = item.label === activeIndex;

                    return (
                      <div
                        key={index}
                        onClick={() => {
                          navigate(item.action); // Navigate to the item's action
                          handleMenuItemClick(item.label, item.action); // Custom logic on click
                        }}
                        className={`flex items-center flex-col bg-black p-1 gap-2 cursor-pointer ${
                          isActive ? " text-primary" : "text-white"
                        }`}
                      >
                        {/* {item.activeIcon && React.createElement(item.icon, { size: 28, className: "mr-4" })} */}
                        {item.activeIcon}
                        <span className="text-[10px]">{item.label}</span>
                      </div>
                    );
                  })}
                </div>
              </div>
              {/* Mobile Nav bar END */}

              <main className="items-start h-[100vh] overflow-x-hidden menu-item-sidebar bg-white  md:ml-[5%] lg:ml-[5%] ">
                <div className="h-full">
                  {/* <div className="h-0 relative top-[28px]">
                    {broken && (
                      <button
                        className="sb-button m-4"
                        onClick={() => setToggled(!toggled)}
                      >
                        <MdOutlineMenu size={"2rem"} />
                      </button>
                    )}
                  </div> */}
                  <Routes className="router-parent">
                    {/* <Route path="/" element={<Recruiter />} /> */}
                    <Route
                      path="/instant-hire"
                      element={<InstantHireCandidates />}
                    />
                    <Route path="/interviews" element={<InterviewsList />} />
                    <Route path="/settings/:id" element={<Profile />} />
                    <Route path="/report/:id" element={<ReportScreen />} />
                    <Route
                      path="/mockexamreport"
                      element={<MockExamReport />}
                    />
                    {/* <Route
                              path="/history"
                              element={<HistoryPage />}
                              children={<Route path="*" element={<HistoryPage />} />}
                            /> */}

                    <Route path="/settings1" element={<RecruiterProf />} />
                    <Route path="/tags" element={<Tags />} />
                    <Route
                      path="/meeting-creation-form"
                      element={<MeetingCreationForm />}
                    />
                    <Route
                      path="/services"
                      element={<Discover />}
                      children={<Route path="*" element={<Discover />} />}
                    />
                    <Route
                      path="/dropdown"
                      element={<SearchableDropdown />}
                      children={
                        <Route path="*" element={<SearchableDropdown />} />
                      }
                    />
                    {/* route for Resume in company portal */}
                    <Route path="/resume" element={<Resume />} />
                    <Route
                      path="/resumescore/:jdId"
                      element={<ResumeScore />}
                    />
                    <Route
                      path="/resumescore/:jdId"
                      element={<ResumeScore />}
                    />

                    {/* route for dashboard in company portal */}
                    <Route path="/dashboard" element={<Dashboard1 />} />
                    {/* route for history in company portal */}
                    <Route path="/activity" element={<History />} />
                    {/* <Route path="/settings2" element={<Selectone />} /> */}
                    <Route path="/jobpost/:id" element={<JobDetails />} />
                    {/* route for applicant in company portal */}
                    <Route
                      path="/applicant/:id"
                      element={<MobileReportOverview />}
                    />
                    {/* route for creating interview for job post in company portal */}
                    <Route path="/services-old" element={<CreateNew />} />
                    <Route path="/job-post" element={<JobPost />} />
                    <Route path="/view-credits" element={<ViewCredits />} />

                    <Route path="/mcq" element={<Mcq skip={false} />} />
                    <Route
                      path="/technical-interview"
                      element={
                        // <Technical
                        //   skip={false}
                        //   fromIndex={true}
                        //   buttonName={"Submit"}
                        // />
                        <TechnicalInterview />
                      }
                    />
                    <Route
                      path="/technical-interview1"
                      element={<TechnicalInterview />}
                    />

                    <Route
                      path="/hr-interview"
                      element={
                        // <HrInterview
                        //   skip={false}
                        //   fromIndex={true}
                        //   buttonName={"Submit"}
                        // />
                        <TechnicalInterview hr={true} />
                      }
                    />
                    <Route path="/settings2" element={<ProgressBar />} />
                    <Route
                      path="/interview"
                      element={<CompanyInterviewsList />}
                    />

                    <Route path="/export" element={<ExportDataUI />} />
                    <Route path="/export2" element={<ExportDataUI1 />} />
                    <Route path="/export3" element={<ExportDataUI3 />} />
                    <Route
                      path="/interview-form"
                      element={<CompanyInterviewForm />}
                    />
                    <Route path="/applicants" element={<ApplicantsDetails />} />
                    <Route
                      path="/mocktest-applicants"
                      element={<ApplicantsDetails mock={true} />}
                    />
                    <Route
                      path="/mocktest-applicants/:id"
                      element={<ApplicantsDetails mock={true} />}
                    />
                    <Route
                      path="/applicants/:id"
                      element={<ApplicantsDetails />}
                    />
                    <Route
                      path="/job-applicants/:id"
                      element={<JobApplicantDetails />}
                    />
                    {/* <Route
                      path="/jobsh"
                      element={<Tags />}
                      children={<Route path="*" element={<Tags />} />}
                    /> */}

                    <Route
                      path="/settings7"
                      element={<Profilepage />}
                      children={<Route path="*" element={<Profilepage />} />}
                    />
                    <Route
                      path="/pricing-plans1"
                      element={<PricingPlans2 />}
                      children={<Route path="*" element={<PricingPlans2 />} />}
                    />
                    <Route
                      path="gowthami2"
                      element={<Component2 />}
                      children={<Route path="*" element={<Component2 />} />}
                    />
                    <Route path="/Home" element={<Assesment1 />} />
                    <Route
                      path="/settings8"
                      element={<ReportOverviewDummy />}
                      children={
                        <Route path="*" element={<ReportOverviewDummy />} />
                      }
                    />
                    <Route
                      path="/settings"
                      element={<ProfilePage1 />}
                      children={<Route path="*" element={<ProfilePage1 />} />}
                    />
                    <Route
                      path="/talent-pool"
                      element={<CompanyApplicants />}
                    />
                    <Route
                      path="/talent-pool-26"
                      element={<InterviewSetting />}
                    />
                    <Route
                      path="/talent-pool-27"
                      element={<InterviewSetting2 />}
                    />
                    <Route
                      path="/talent-pool-28"
                      element={<ScreenShareErrorCard />}
                    />
                    <Route
                      path="/talent-pool-29"
                      element={<ExportApplicant />}
                    />
                    <Route
                      path="/talent-pool-54"
                      element={<TotalApplicantsMobile />}
                    />
                    <Route
                      path="/pricing-plan"
                      element={<PricePlans isStudent1={false} />}
                    />
                    <Route
                      path="/Subscription"
                      element={
                        <Subscription
                          plans={companyPlans}
                          yearlyPlans={yearlyPlans}
                        />
                      }
                    />
                    <Route path="/checkout" element={<CheckoutPage />} />
                  </Routes>
                </div>
              </main>
            </div>
          </div>
        </>
      )}
    </Observer>
  );
}
